import { render, staticRenderFns } from "./general_report_mdr.vue?vue&type=template&id=50a5934c"
import script from "./general_report_mdr.vue?vue&type=script&lang=js"
export * from "./general_report_mdr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports